module.exports = __webpack_public_path__ + "img/Stephen Larcia.584dd7e0.jpg";